<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  (onAdd)="onCreate()"
  (sortObject)="getSortItems($event)"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
  (onShowHelpPage)="onShowHelpPage()"
  (onRefresh)="onReset()"
>
  <div class="card-toolbar" after-btns>
    <!-- back btn -->
    <div [matTooltip]="'common.back' | translate">
      <a
        class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
        mat-ripple
        [matTooltip]="'common.back' | translate"
        (click)="onBack()"
      >
        <i class="mdi mdi-arrow-left mdi-20px tw-p-0"></i>
      </a>
    </div>
  </div>
  <!--------------------------------------- Table Content --------------------------------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-p-4">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- cellPhone -->
        <td>
          <td-value copyToClipboard [value]="item?.cellPhone"></td-value>
        </td>

        <!-- mobileOperator -->
        <td class="tw-py-2">
          <div
            class="tw-flex-center"
            [matTooltip]="
              item?.mobileOperator | enumToText : SmsAggregatorsEnumValues
            "
            [mobileOperatorImg]="{
              mobileOperator: item?.mobileOperator,
              mobileOperatorEnumValue:
                item?.mobileOperator | enumToText : SmsAggregatorsEnumValues
            }"
          ></div>
        </td>

        <!-- histories -->
        <td>
          <app-expand-item
            *ngIf="item?.histories?.length > 1"
            [isCustom]="true"
            [placement]="'right'"
          >
            <ul class="custom tw-mb-0">
              <li *ngFor="let item of item?.histories" class="tw-mb-1">
                {{
                  item
                    | dateTimeConvertor : translationService.currentLang()
                    | checkValue
                }}
              </li>
            </ul>
          </app-expand-item>

          <td-value
            *ngIf="item?.histories?.length < 2"
            copyToClipboard
            type="dateTime"
            [value]="item?.histories[0]"
          >
          </td-value>
        </td>
        <!-- created -->
        <td>
          <td-value type="dateTime" [value]="item?.created"></td-value>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!--------------------------------------- help --------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="pageName"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
